import { useFeatureFlags } from './useFeatureFlags';

export function useIsFeatureOff(featureName: string) {
  const { featureFlags } = useFeatureFlags();

  return featureFlags.isFeatureOff(featureName);
}
